import React from "react";
import { useEffect } from "react";
import { useState } from "react";

/**
 * PC_Tc_04 getEmpTeamData gets imported from api.js file
 */
import { getEmpTeamData } from "../service/api";
import '../components/css/Dashboard-styles.css'

const EmployeeTeam = () => {


    /**
     * PC_Tc_02
     * The data , carouselArray , count  state variable is created for storing the response data
     */


    const [data, setData] = useState([]);

    const [carouselArray, setCarouselArray] = useState([]);

    const [count, setCount] = useState(0)

    /**
* PC_Tc_03
* Use Efffect method is called 
*/

    useEffect(() => {

        fetchApi()

    }, []);


    /**
* PC_Tc_06
* The fetchApi function in the useEffects gets invoked which inturn call the getEmpTeamData() function with respective parameters
*/

    const fetchApi = async () => {

        const resp = await getEmpTeamData()

        if (resp?.data?.ResponseData?.length > 0) {

            setData(resp.data.ResponseData)

            setCount(resp?.data?.ResponseData.length)

            let arr = [], mainArr = []

            resp.data.ResponseData.forEach((emp) => {

                if (arr.length < 6) {

                    arr.push(emp)

                    if (arr.length == 6 || resp.data.ResponseData.indexOf(emp) == resp.data.ResponseData.length - 1 || resp.data.ResponseData.length == mainArr.flat(1).length) {

                        mainArr.push(arr);

                        arr = [];
                    }
                }

            })

            setCarouselArray(mainArr)

        }



    }

    const teamBody = (carousel) => {

        try {

            return (

                carousel.map((datum) => {

                    let randNum = Math.floor(Math.random() * (6 - 1 + 1)) + 1;

                    return (<div className="p-2 col-md-2 text-center">
                        <span ><img src="/Images/logo-person-user-person-icon.jpg" className={`dashboard-myteam-dash-profile-size myteam-profile-border-${randNum}`} />
                        </span>
                        <h2 className="font-11 bold-text mt-2 mb-0 ">{datum.emp_name}
                            <span>
                                <p className="semibold-text lable-color2 font-11">{datum.domain}</p>
                            </span>
                        </h2>
                    </div>
                    )
                })
            )
        }
        catch (err) {


        }


    }

    /**
* PC_Tc_10
* The response data gets stored in the data variable and mapped to the respective divs
*/
    return (
        <>

            <div className="dashboard-container-background mt-3 dashboard-team-card-size">
                <div>
                    <h1 className="tt-bold font-15 pt-3 ps-3">{`My Team (${count}) `}</h1>
                </div>
                <div className="justify-content-around ms-3">
                    <div id="carouselTeamMembers" className="carousel slide" data-bs-ride="carousel">
                        <div className="carousel-inner">

                            {
                                (carouselArray.map((carousel, j) => {

                                    //
                                    return (
                                        <div className={`carousel-item ${j == 0 ? 'active' : null} `}>
                                            <div className="row pt-4">
                                                {teamBody(carousel)}
                                            </div>
                                        </div>

                                    )
                                }))
                            }

                            {/* <div className="carousel-item ">
                                <div className="row pt-4"> */}
                            {/* {teamBody()} */}
                            {/* </div> */}
                            {/* </div> */}
                            {/* <div class="carousel-item">
                                          
                                        </div> */}

                            {
                                carouselArray.length > 1 ? <>
                                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselTeamMembers" data-bs-slide="prev">
                                        <span className="carousel-control-prev-icon" aria-hidden="true" />
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button className="carousel-control-next" type="button" data-bs-target="#carouselTeamMembers" data-bs-slide="next">
                                        <span className="carousel-control-next-icon" aria-hidden="true" />
                                        <span className="visually-hidden">Next</span>
                                    </button></> : <></>
                            }


                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default EmployeeTeam